import dayjs from 'utils/extendedDayJS';

export const calculateInitialDateTimeSettings = (): {
  startDateTime: Date;
  endDateTime: Date;
} => {
  const now = new Date();
  const startDateCandidate = new Date(now);
  startDateCandidate.setDate(now.getDate() + 1); // Set startDate to tomorrow

  let startHour = now.getHours();
  const currentMinute = now.getMinutes();

  if (currentMinute >= 30) {
    startHour = (startHour + 1) % 24;
  }
  const startMinutes = 0; // Rounded to nearest HH:00

  const finalStartDateTime = dayjs(startDateCandidate)
    .hour(startHour)
    .minute(startMinutes)
    .second(0)
    .millisecond(0)
    .toDate();
  const finalEndDateTime = dayjs(finalStartDateTime).add(1, 'hour').toDate();

  return {
    startDateTime: finalStartDateTime,
    endDateTime: finalEndDateTime
  };
};

export const calculateInitialDateSettings = (): {
  startDate: Date;
  endDate: Date;
} => {
  const startDate = dayjs().add(1, 'day').startOf('day').toDate();
  const endDate = dayjs(startDate).add(1, 'day').startOf('day').toDate();

  return {
    startDate,
    endDate
  };
};
